import { BigNumber, ethers } from "ethers";

export const convertEarningPercent = (value: BigNumber) => {
  const converted = Number(ethers.utils.formatUnits(value, 12));
  return Math.round((converted * 100 + Number.EPSILON) * 100) / 100;
};
